import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { drName } from "../redux/apiUrl";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#fff",
    height: "100%",
    paddingBottom: 70, // Último valor definido
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 20,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  logo: {
    width: "auto",
    height: 75, // Último valor definido
  },
  headerright: {
    width: "auto",
    height: "45%", // Último valor definido
  },
  headerright: {
    width: "auto",
    height: "40%", // Último valor definido
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    color: "#000",
    marginBottom: 20,
  },
  subtitle: {
    textAlign: "left",
    fontSize: 14, // Último valor definido
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 700,
    marginBottom: 20,
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  bold: {
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 600,
  },
  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#000",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.2, // Último valor definido
    zIndex: "-10",
  },
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
  },
  information_title: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    fontFamily: "Roboto",
    paddingTop: 10,
    paddingBottom: 10,
  },
  // Propiedades faltantes del primer objeto
  gridItem: {
    width: "48%",
    marginBottom: 5,
  },
  singleItem: {
    width: "100%",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 5,
    fontFamily: "Roboto",
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    marginRight: 20,
    textAlign: "center",
    paddingTop: 80,
  },
  columDr: {
    flex: 1,
    textAlign: "center",
    marginLeft: 20,
  },
  firma: {
    width: 90,
    marginLeft: "42%",
    height: 80,
  },
});
const OrdenPdf = ({ data }) => {
  const orden = [];
  if (data.orden.tipo !== "Analisis de Gabinete")
    Object.keys(data.orden).forEach((key) => {
      if (
        data?.orden[key] &&
        !key.includes("resultado") &&
        !key.includes("_at") &&
        key !== "nombre" &&
        key !== "tipo" &&
        key !== "id" &&
        key !== "cita_id"
      ) {
        orden.push(key.replaceAll("_", " ").toUpperCase());
      }
    });

  return (
    <Document>
      <Page style={styles.page}>
        <Image style={styles.watermark} src="/images/longLogo.png" />
        {/* Header */}
        <View style={styles.header}>
          <Image style={styles.logo} src="/images/smallLogo.png" />
          <Image style={styles.headerright} src="/images/headerright.png" />
        </View>

        {/* Title */}
        <Text style={styles.title}>ORDEN DE ESTUDIOS</Text>

        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Nombre:</Text> {data?.nombre}
            </Text>
            {/* <Text style={styles.text}>
              <Text style={styles.textBold}>Edad:</Text> {data?.edad}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Lugar de atención:</Text>{" "}
              {data?.lugarAtencion}
            </Text> */}
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {data?.fecha}
            </Text>
            {/* <Text style={styles.text}>
              <Text style={styles.textBold}>Seguro:</Text> {data?.seguro}
            </Text> */}
            {data?.orden?.tipo && (
              <Text style={styles.text}>
                <Text style={styles.textBold}>Tipo:</Text> {data?.orden?.tipo}
              </Text>
            )}
          </View>
        </View>

        {/* Receta Details */}
        <View style={styles.section}>
          <Text style={styles.text}>
            <Text style={styles.textBold}></Text>
          </Text>

          {orden.length > 0 ? (
            orden.map((val, index) => (
              <View style={styles.section} key={val}>
                <Text style={styles.text}>{`${index + 1}). ${val}`}</Text>
              </View>
            ))
          ) : (
            <View style={styles.section}>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Nombre:</Text>{" "}
                {data?.orden?.nombre}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Descripción:</Text>{" "}
                {data?.orden?.descripcion}
              </Text>
            </View>
          )}
        </View>

        <View style={styles.firmas}>
          <View style={styles.columDr}>
            <Image style={styles.firma} src="/images/firma.png" />
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>{data?.doctor?.printer_name}</Text>
            <Text style={styles.text}>{data?.doctor?.specialty}</Text>
          </View>
        </View>

        {/* Footer */}
        {/* <Image fixed style={styles.footerImage} src="/images/footerImage.png" /> */}
      </Page>
    </Document>
  );
};

export default OrdenPdf;
